export const addCacheBuster = (url: string, param = '_'): string => {
    try {
        const parsedUrl = new URL(url);
        parsedUrl.searchParams.set(param, Date.now().toString());
        return parsedUrl.toString();
    } catch {
        return url;
    }
};
